import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
import * as api from './api';

const TOKEN_KEY = 'auth_token';

const AuthService = {
  // Ghi token vào cookie
  saveToken(token) {
    Cookies.set(TOKEN_KEY, token, { expires: 1, secure: true });
  },

  // Lấy token từ cookie
  getToken() {
    return Cookies.get(TOKEN_KEY);
  },

  // Xóa token
  clearToken() {
    Cookies.remove(TOKEN_KEY);
  },

  // Giải mã token
  decodeToken() {
    const token = this.getToken();
    if (!token) return null;

    try {
      return jwtDecode(token); // { id, iat, exp }
    } catch (err) {
      console.error('Token không hợp lệ:', err);
      return null;
    }
  },

  // Kiểm tra đăng nhập
  isAuthenticated() {
    const decoded = this.decodeToken();
    if (!decoded) return false;

    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  },

  // Trả thông tin người dùng từ token
  getCurrentUser() {
    if (!this.isAuthenticated()) return null;

    return this.decodeToken(); // hoặc gọi API để lấy chi tiết hơn
  },

  // Đăng nhập
  async login(email, password) {
    try {
      const response = await api.login(email, password);
      const token = response.data.token;
      this.saveToken(token);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Đăng ký
  async register(username, email, password, confirmPassword) {
    try {
      const response = await api.register(username, email, password, confirmPassword);
      const token = response.data.token;
      if (token) {
        this.saveToken(token);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async requestPasswordReset(email) {
    try {
      const response = await api.requestPasswordReset(email);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Đặt lại mật khẩu
  async resetPassword(token, password) {
    try {
      const response = await api.resetPassword({ token, password });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy thông tin người dùng từ API
  async fetchUserProfile() {
    try {
      const response = await api.getProfile();
      return response.data;
    } catch (error) {
      console.error('Lỗi khi lấy thông tin người dùng:', error);
      return null;
    }
  }
};

export default AuthService;
